import { FC } from 'react';

export const CareerAdventure: FC = () => {
  window.location.replace('https://witgritfit.com/my-career-adventure/');
  return null;
};
